export const FETCH_ADMINS = 'FETCH_ADMINS';
export const UPDATE_ADMIN = 'UPDATE_ADMIN';
export const FETCH_ACTIVITIES = 'FETCH_ACTIVITIES';
export const FETCH_ACTIVITY_SNAPSHOT = 'FETCH_ACTIVITY_SNAPSHOT';
export const GET_ROLES = 'GET_ROLES';
export const FETCH_ROLE_PERMISSIONS = 'FETCH_ROLE_PERMISSIONS';
export const GET_GROUPS = 'GET_GROUPS';
export const FETCH_CHALLENGES = 'FETCH_CHALLENGES';
export const FETCH_CHALLENGE_CATEGORIES = 'FETCH_CHALLENGE_CATEGORIES';
export const FETCH_CHALLENGES_FOR_USER = 'FETCH_CHALLENGES_FOR_USER';